// extracted by mini-css-extract-plugin
export var actions = "_6j-8";
export var arrow = "_6j-5";
export var card = "_6j-0";
export var cardWrapper = "_6j-9";
export var fieldName = "_6j-3";
export var newValue = "_6j-6";
export var oldValue = "_6j-4";
export var orangeGlowFade = "_6j-c";
export var productSection = "_6j-1";
export var scrollToBottom = "_6j-b";
export var scrollToBottomAnchor = "_6j-a";
export var scrollToBottomIcon = "_6j-d";
export var showAllButton = "_6j-7";
export var table = "_6j-2";